import { tv } from 'tailwind-variants'

export const loadingVariants = tv({
  slots: {
    container: 'flex flex-col w-full justify-center items-center content-center'
  }
})
